var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8332 9.16675L19.6665 15.0001L27.8332 20.8334V9.16675Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 6.83325H4.49984C3.21117 6.83325 2.1665 7.87792 2.1665 9.16659V20.8333C2.1665 22.1219 3.21117 23.1666 4.49984 23.1666H17.3332C18.6218 23.1666 19.6665 22.1219 19.6665 20.8333V9.16659C19.6665 7.87792 18.6218 6.83325 17.3332 6.83325Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.6ca7919cfc62331b265517ce1b88003e.svg";
export { ForwardRef as ReactComponent };